import axios from 'axios'
// import Storage from '@/utils/localstorage'
import _ from '@/utils/util'
import store from '@/store'

axios.defaults.timeout = 20000
// axios.defaults.withCredentials = true

// function getOff () {
//   const eid = _.cookieGet(Storage.get('NCG-eid'))
//   return _.getOffset2(eid)
// }

function isTrue (url) {
  return url && url.indexOf('/v2/') > -1
}

axios.interceptors.request.use(function (config) {
    const token = store.state.token
    config.headers['X-Platform'] = _.getXPlatform()
    const channel = _.getXChannel()
    channel && (config.headers['X-Channel'] = channel)
    // v2 接口添加header
    if (isTrue(config.url)) {
      config.headers.Authorization = 'Bearer ' + token
      // 加密配置
      const encrypt = !!(+process.env.VUE_APP_ENCRYPT)
      const debug = !!store.state.user.debug
      if (encrypt && !debug) {
        config.headers['content-type'] = 'application/octet-stream'
        if (config.data) {
          config.data = _.offsetEn(store.state.OFFSET, JSON.stringify(config.data))
        }
      }
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })

// status状态码ok判断
axios.interceptors.response.use((res) => {
  const data = res.data || {}
  const url =  res.request.responseURL
  store.commit('setOnline', true)
  if (isTrue(url) && typeof(data) === 'string') {
    const string = _.offsetOut(store.state.OFFSET, data)
    return JSON.parse(string)
  }
  return data
}, (error) => {
  console.log('axios', error, error.message)
  const code = error.message ? 500 : 'cancel'
  const response = error.response || {
    request: {},
    data: {
      code: code,
      errmsgcn: '网络异常，请稍后重试'
    }
  }
  const url = response.request.responseURL
  const data = response.data
  // // 401 认证错误 且非登录页
  // if (response.status == 401 && window.location.pathname.indexOf('register') == -1) {
  //   // 部分接口不做处理
  //   const  responseURL = error.request.responseURL || ''
  //   // 发送状态不处理
  //   if (responseURL.indexOf('network-status') > -1) {
  //     return  Promise.reject(response)
  //   }
  //   // 平台回到测速页,其它回到登录页
  //   const gameCode = _.getQuerys('code')
  //   const isApp = _.getDetect().os.tv || _.getDetect().os.single // tv或者单个apk
  //   const url = isApp ? 'indexapp.html?code=' + gameCode : 'register.html?rul=' + encodeURIComponent('index.html')
  //   _.locReplace(url)
  //   return false
  // }
  if (url && isTrue(url) && typeof(data) === 'string') {
    try {
      response.data = JSON.parse(_.offsetOut(store.state.OFFSET, data))
    } catch (e) {
      console.log(e)
      response.data = {
        code: code,
        errmsgcn: '网络异常，请稍后重试'
      }
    }
  }
  // if (response.data.code == 500) {
  //   store.commit('setOnline', false)
  // }
  return Promise.reject(response)
})

export default axios
